<template>
  <a :href="href"><slot /></a>
</template>

<script>
export default {
  props: ["href"],
};
</script>

<style lang="scss" scoped>
a {
  color: white !important;
  font-size: 14px;
  background: $dark-teal;
  font-family: $primary-font;
  font-weight: 800;
  padding: 2rem 2rem;
  transition: background-color 0.25s ease-out;
  display: block;
  letter-spacing: 3px;
  text-align: center;
  width: 100%;
  text-transform: uppercase;

  &:hover {
    background: $primary-teal;
  }
}
</style>
